import React from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import BaseSelect from 'components/baseSelect';
import { Field } from 'formik';

const SolicitudHorario = ({errors, touched, handleChange, values, element, removePhoneNumber, options, InputMask, empresaId = 96, index}) => {
    const onRemovePhoneNumber = () => removePhoneNumber(element.id);

    const alignEnd = {
        display: 'flex',
        alignItems: 'flex-end'
    }
    
    const alignCenter = {
        display: 'flex',
        alignItems: 'center'
    }

    return (
        <>
            <BaseSelect
                md={12}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                values={values}
                label={'Horario *'}
                name={`horarioTipoId_${element.id}`}
                url={'HorarioTipo?$filter=empresaId eq ' + empresaId} 
            />

            <Form.Group  as={Col} md="12" id={`feriadoValidation_${element.id}`}>
                <div >
                    <Form.Label> Disponibilidad </Form.Label>
                    &nbsp;&nbsp; <Field type="checkbox" name={`trabajaDiasSemana_${element.id}`}/>
                    {' '} Lunes a viernes
                    &nbsp;&nbsp; <Field type="checkbox" name={`trabajaSabado_${element.id}`}/>
                    {' '} Sábado
                    &nbsp;&nbsp; <Field type="checkbox" name={`trabajaDomingo_${element.id}`}/>
                    {' '} Domingo
                </div>
            </Form.Group>
            
            <Form.Group as={Col} md="6" style={!!errors[`phoneNumber_${element.id}`] ? alignCenter : alignEnd}>
                {
                    index != 0 &&
                    <Button onClick={onRemovePhoneNumber} variant="outline-primary"><i className="fas fa-trash-alt"></i></Button>
                }
            </Form.Group>
        </>
    )
}

export default SolicitudHorario;